// EN | 中文 switch in the widget's header: the language the Root Agent answers
// in, and so the language the avatar reads replies aloud in. Styled for the
// coloured header like AutoSpeakToggle — white on translucent, the picked side
// solid.
const OPTIONS = [
  { value: "en", label: "EN", title: "Answer in English" },
  { value: "zh", label: "中文", title: "Answer in Traditional Chinese" },
];

const LanguageToggle = ({ language, onChange }) => (
  <div
    role="radiogroup"
    aria-label="Answer language"
    className="flex shrink-0 items-center rounded-lg p-0.5"
    style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
  >
    {OPTIONS.map(({ value, label, title }) => {
      const active = language === value;
      return (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={active}
          onClick={() => !active && onChange(value)}
          title={title}
          className="rounded-md px-2 py-1 text-xs font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
          style={{
            backgroundColor: active ? "rgba(255,255,255,0.9)" : "transparent",
            color: active ? "#374151" : "#ffffff",
          }}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default LanguageToggle;
